import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useRef } from 'react';
import { AuthenticationState } from "react-aad-msal";
import { connect } from 'react-redux';
import { withFormik } from 'formik';
import * as yup from 'yup';
import { accountHelper, formatter, getLoyaltyStorage } from "../../util";
import { useHistory } from "react-router-dom";
import { Button, Container, Row, Col, Collapse } from 'react-bootstrap';
import MediaQuery from "react-responsive";
import Heading from '../heading/Heading';
import { Loading } from '../state';
import { ImClipboard } from 'react-icons/im';
import waitlistconfirm from '../../images/svg/waitlistconfirm.svg';
import { StateBootstrapButton as StateButton } from '../forms/elements'; // Utils

import { formStart, formComplete } from '../../util';
import { FormikWizardProvider, Wizard, StepsList, Step, ButtonsList, PreviousButton, NextButton, SubmitButton } from 'formik-wizard-form'; // Validation schema

import { validation, required } from './util/validation'; // import PartySize from './Waitlist/PartySize';

import PartySize from './Waitlist/PartySizeNoLocation';
import LocationPicker from './Waitlist/LocationPicker';
import BasicInfo from './Waitlist/BasicInfo';
import InlineError from '../state/InlineError';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { mobileAppUtil } from '../../util/mobileAppUtil'; // import { Debug } from './Debug';
// Redux

import { waitlistDuck } from "../../ducks/waitlist";
import { locationDuck } from "../../ducks/location";
var waitlistOperations = waitlistDuck.operations;
var locationOperations = locationDuck.operations;

var formCompleteTracker = function formCompleteTracker(props) {
  formComplete({
    identifier: 'WaitlistFormPage',
    name: 'Waitlist',
    partySize: props.partySize
  });
};

var formikEnhancer = withFormik({
  enableReinitialize: true,
  mapPropsToValues: function mapPropsToValues(props) {
    return {
      partySize: props.partySize,
      firstName: props.firstName,
      lastName: props.lastName,
      location: props.location,
      emailAddress: props.emailAddress,
      phoneNumber: props.phoneNumber,
      zipCode: props.zipCode,
      termsAndConditions: props.termsAndConditions,
      newsletter: props.newsletter,
      results: props.results,
      isFetching: props.isFetching
    };
  },
  validationSchema: yup.object().shape({
    partySize: required('Party size is required'),
    location: required('You must select a location first'),
    firstName: validation.firstName,
    lastName: validation.lastName,
    emailAddress: validation.wlEmailAddress,
    phoneNumber: validation.phoneNumber,
    zipCode: validation.wlZipcode
  }),
  handleSubmit: function handleSubmit(values, _ref) {
    var props = _ref.props;

    if (typeof props.postWaitlist !== 'function') {
      return false;
    }

    formCompleteTracker(props);
    var action = props.confirmation && props.storeId === props.waitlistId ? props.updateWaitlist : props.postWaitlist;
    return action();
  },
  displayName: "WaitlistFormPage" // helps with React DevTools

});

var partySizeValidation = function partySizeValidation(_ref2) {
  var errors = _ref2.errors;
  return !errors.partySize;
};

var locationValidation = function locationValidation(_ref3) {
  var errors = _ref3.errors;
  return !errors.location;
};

var basicInfoValidation = function basicInfoValidation(_ref4) {
  var errors = _ref4.errors;
  return !errors.firstName && !errors.lastName && !errors.phoneNumber && !errors.emailAddress && !errors.zipCode;
};

var WaitlistFormPage = function WaitlistFormPage(props) {
  var _location$storename, _props$location, _props$location2;

  var values = props.values,
      touched = props.touched,
      errors = props.errors,
      dirty = props.dirty,
      isSubmitting = props.isSubmitting,
      handleChange = props.handleChange,
      handleBlur = props.handleBlur,
      handleSubmit = props.handleSubmit,
      handleReset = props.handleReset,
      store = props.store,
      err = props.err,
      showForm = props.showForm,
      confirmation = props.confirmation,
      isLoading = props.isLoading,
      location = props.location,
      isFetching = props.isFetching,
      _props$disclaimer = props.disclaimer,
      disclaimer = _props$disclaimer === void 0 ? {} : _props$disclaimer,
      toggleForm = props.toggleForm,
      checkWaitlistAvailable = props.checkWaitlistAvailable,
      getMenu = props.getMenu,
      checkedIn = props.checkedIn,
      getWaitlist = props.getWaitlist,
      cancelWaitlist = props.cancelWaitlist,
      storeId = props.storeId,
      waitlistId = props.waitlistId;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      confirmActive = _useState2[0],
      setConfirmActive = _useState2[1];

  var history = useHistory();

  var formStartTracker = function formStartTracker() {
    formStart({
      identifier: 'WaitlistFormPage',
      name: 'Waitlist'
    });
  }; // Check Waitlist status


  useEffect(function () {
    formStartTracker();
    getWaitlist();
  }, []);
  useEffect(function () {}, [err.error]);
  useEffect(function () {
    if (props.location) {
      checkWaitlistAvailable();

      if (storeId === waitlistId) {
        console.log('Matching store');

        if (showForm) {
          console.log('Form off, turn it on');
          toggleForm();
        }
      } else {
        console.log('Different store');

        if (!showForm) {
          console.log('hide form');
          toggleForm();
        }
      }
    }
  }, [props.location]);

  var handleCancel = function handleCancel() {
    setConfirmActive(false);
    cancelWaitlist();
    history.push('/');
  };

  var verifyLocation = function verifyLocation() {
    if (props.location == null) {
      alert('You must choose a location first');
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, confirmActive && showForm && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "waitListOverlayClickBlock",
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: '9900',
      textAlign: 'center',
      width: '2000px',
      height: '2000px',
      border: '1px solid #ddd',
      padding: '40px 10px 25px 10px',
      overflow: 'hidden'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "waitListOverlay",
    style: {
      position: 'absolute',
      top: '75%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: '9999',
      textAlign: 'center',
      width: '375px',
      height: 'auto',
      background: 'white',
      border: '1px solid #ddd',
      padding: '40px 10px 25px 10px',
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      margin: '0 0 0 0'
    }
  }, "Are you sure you want to cancel your place on the waitlist?"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    style: {
      width: '110px',
      minWidth: '10px'
    },
    id: "",
    onClick: function onClick() {
      return setConfirmActive(false);
    },
    className: "cb-button-primary"
  }, "No"), /*#__PURE__*/React.createElement(Button, {
    style: {
      width: '110px',
      minWidth: '10px',
      marginLeft: '20px'
    },
    id: "",
    type: "submit",
    onClick: handleCancel,
    disabled: isLoading,
    className: "cb-button-secondary"
  }, "Yes"))), /*#__PURE__*/React.createElement(InlineError, {
    store: store,
    error: err
  }), showForm ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Loading, {
    isLoading: isLoading
  }),
  /* {(location && !location.data) &&  */
  !isLoading ? /*#__PURE__*/React.createElement(FormikWizardProvider, _extends({}, props, {
    enableReinitialize: true
  }), function (_ref5) {
    var getValidators = _ref5.getValidators,
        otherProps = _objectWithoutProperties(_ref5, ["getValidators"]);

    return /*#__PURE__*/React.createElement(Wizard, otherProps, /*#__PURE__*/React.createElement(StepsList, {
      validators: getValidators([locationValidation, partySizeValidation, basicInfoValidation])
    }, /*#__PURE__*/React.createElement(Step, _extends({
      component: LocationPicker,
      title: "Location",
      changeHandler: props.changeHandler,
      setConfirmActive: setConfirmActive
    }, props)), /*#__PURE__*/React.createElement(Step, _extends({
      component: PartySize,
      store: store,
      title: "Party Size",
      location: location,
      isFetching: isFetching,
      changeHandler: props.changeHandler,
      setConfirmActive: setConfirmActive,
      confirmation: props.waitlistConfirmation,
      storeId: props.storeId,
      waitlistId: props.waitlistId
    }, props)), /*#__PURE__*/React.createElement(Step, _extends({
      component: BasicInfo,
      title: "Guest Information",
      changeHandler: props.changeHandler
    }, props))), /*#__PURE__*/React.createElement(ButtonsList, null, /*#__PURE__*/React.createElement(PreviousButton, {
      className: "",
      style: {
        minWidth: '50%'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      id: "waitlist-previous",
      style: {
        minWidth: '50%'
      },
      className: "cb-button-secondary"
    }, "Previous")), /*#__PURE__*/React.createElement(NextButton, {
      className: "next "
    }, /*#__PURE__*/React.createElement(Button, {
      id: "waitlist-next",
      style: {
        maxWidth: '40%'
      },
      onClick: verifyLocation,
      className: "cb-button-primary"
    }, "Next")), /*#__PURE__*/React.createElement(SubmitButton, {
      className: ""
    }, /*#__PURE__*/React.createElement(StateButton, {
      id: "waitlist-submit",
      style: {
        maxWidth: '40%'
      },
      type: "submit",
      loading: isLoading,
      disabled: isLoading,
      className: "cb-button-primary"
    }, "Submit"))));
  }) : null, mobileAppUtil.isMobileApp() ? /*#__PURE__*/React.createElement("div", {
    className: "cb-form__waitlist--disclaimer"
  }, disclaimer) : /*#__PURE__*/React.createElement(RichText, {
    field: disclaimer,
    className: "cb-form__waitlist--disclaimer"
  }), /*#__PURE__*/React.createElement("span", {
    className: "partySize visuallyhidden"
  }, values.partySize), /*#__PURE__*/React.createElement("span", {
    className: "storelocation visuallyhidden"
  }, location === null || location === void 0 ? void 0 : (_location$storename = location.storename) === null || _location$storename === void 0 ? void 0 : _location$storename.value)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Container, {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement("h1", {
    className: "cb-banner__title cb-color-brown-500"
  }, " ", /*#__PURE__*/React.createElement("strong", null, "Success !")), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontFamily: 'Veneer_Clean',
      fontSize: '1.3rem'
    },
    className: "cb-color-brown-500"
  }, "YOU'RE ON THE LIST"))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("img", {
    className: "mb-3 mt-3",
    src: waitlistconfirm
  }), /*#__PURE__*/React.createElement("p", {
    className: "cb-color-brown-400"
  }, "We sent your confirmation via text."), /*#__PURE__*/React.createElement("br", null), ((_props$location = props.location) === null || _props$location === void 0 ? void 0 : _props$location.EnableWaitlistCheckin) ? Boolean(checkedIn) ? /*#__PURE__*/React.createElement("p", {
    className: "cb-color-brown-400"
  }, "You are currently checked in") : /*#__PURE__*/React.createElement("p", {
    className: "cb-color-brown-400"
  }, /*#__PURE__*/React.createElement("b", null, "When you arrive:"), " Tap the \"I'm Here\" button below to confirm your arrival. We'll text you when it's your turn!") : /*#__PURE__*/React.createElement("div", null))), /*#__PURE__*/React.createElement(Collapse, {
    in: !confirmActive
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-l-margin-medium--top"
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, Boolean(checkedIn) ? /*#__PURE__*/React.createElement(Button, {
    style: {
      paddingLeft: "0px",
      paddingRight: "0px"
    },
    className: "cb-button-primary",
    onClick: function onClick() {
      history.push("/"); // return setConfirmActive(true);
    }
  }, "Return Home") : /*#__PURE__*/React.createElement(Button, {
    style: {
      paddingLeft: "0px",
      paddingRight: "0px"
    },
    className: "cb-button-secondary",
    onClick: function onClick() {
      return toggleForm();
    }
  }, "Edit Wait List Details")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary",
    onClick: function onClick() {
      //  setConfirmActive(true);
      setTimeout(function () {
        history.push("/menu");
      }, 200);
    }
  }, "Browse the menu")))), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, Boolean(checkedIn) ? /*#__PURE__*/React.createElement(Button, {
    style: {
      paddingLeft: "0px",
      paddingRight: "0px",
      marginBottom: "16px"
    },
    className: "cb-button-primary",
    onClick: function onClick() {
      history.push("/"); // return setConfirmActive(true);
    }
  }, "Return Home") : /*#__PURE__*/React.createElement(Button, {
    style: {
      paddingLeft: "0px",
      paddingRight: "0px",
      marginBottom: "16px"
    },
    className: "cb-button-secondary",
    onClick: function onClick() {
      return toggleForm();
    }
  }, "Edit Wait List Details"), /*#__PURE__*/React.createElement("br", null), ((_props$location2 = props.location) === null || _props$location2 === void 0 ? void 0 : _props$location2.EnableWaitlistCheckin) ? Boolean(checkedIn) ? /*#__PURE__*/React.createElement("div", null) : /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary",
    onClick: props === null || props === void 0 ? void 0 : props.checkInWaitlist
  }, "I'm Here") : /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary",
    onClick: function onClick() {
      //  setConfirmActive(true);
      setTimeout(function () {
        history.push("/menu");
      }, 200);
    }
  }, "Browse the menu")))), /*#__PURE__*/React.createElement(Collapse, {
    in: confirmActive
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-l-margin-medium--top"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: "cb-type--center",
    onClick: true
  }, "Are you sure you want to cancel your place on the waitlist?"))), /*#__PURE__*/React.createElement(Row, {
    className: "cb-l-margin-medium--top"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary",
    onClick: function onClick() {
      return setConfirmActive(false);
    }
  }, "No")), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-secondary",
    onClick: function onClick() {
      return handleCancel();
    }
  }, "Yes"))))))));
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$account, _loyaltyStorage$accou, _loyaltyStorage$accou2, _loyaltyStorage$accou3, _loyaltyStorage$accou4;

  var account = accountHelper((_state$account = state.account) === null || _state$account === void 0 ? void 0 : _state$account.aadResponse);
  var loyaltyStorage = getLoyaltyStorage();
  return {
    account: state.account,
    location: state.location.location,
    showForm: state.waitlist.showForm,
    partySize: state.waitlist.partySize,
    firstName: state.waitlist.firstName || (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou = loyaltyStorage.account) === null || _loyaltyStorage$accou === void 0 ? void 0 : _loyaltyStorage$accou.FirstName) || '',
    lastName: state.waitlist.lastName || (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou2 = loyaltyStorage.account) === null || _loyaltyStorage$accou2 === void 0 ? void 0 : _loyaltyStorage$accou2.LastName) || '',
    phoneNumber: state.waitlist.phoneNumber || (typeof (loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou3 = loyaltyStorage.account) === null || _loyaltyStorage$accou3 === void 0 ? void 0 : _loyaltyStorage$accou3.HomePhone) !== 'undefined' ? formatter.phone(loyaltyStorage === null || loyaltyStorage === void 0 ? void 0 : (_loyaltyStorage$accou4 = loyaltyStorage.account) === null || _loyaltyStorage$accou4 === void 0 ? void 0 : _loyaltyStorage$accou4.HomePhone) : ''),
    emailAddress: state.waitlist.emailAddress || (typeof account.emails !== 'undefined' ? account.emails[0] : account === null || account === void 0 ? void 0 : account.email),
    zipCode: state.waitlist.zipCode,
    newsletter: state.waitlist.newsletter,
    results: state.waitlist.results,
    checkedIn: state.waitlist.checkedIn,
    confirmation: state.waitlist.confirmation,
    storeId: state.waitlist.storeId,
    waitlistId: state.location.waitlistId,
    isError: state.error.isError,
    err: state.error.err,
    isLoading: state.waitlist.isLoading,
    hasActiveWaitlist: state.waitlist.storeId && state.waitlist.confirmation
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    checkWaitlistAvailable: function checkWaitlistAvailable() {
      return dispatch(waitlistOperations.checkWaitlistAvailable());
    },
    postWaitlist: function postWaitlist() {
      return dispatch(waitlistOperations.postWaitlist());
    },
    updateWaitlist: function updateWaitlist() {
      return dispatch(waitlistOperations.updateWaitlist());
    },
    getWaitlist: function getWaitlist() {
      return dispatch(waitlistOperations.getWaitlist());
    },
    toggleForm: function toggleForm() {
      return dispatch(waitlistOperations.toggleForm());
    },
    cancelWaitlist: function cancelWaitlist() {
      return dispatch(waitlistOperations.cancelWaitlist());
    },
    changeHandler: function changeHandler(e) {
      return dispatch(waitlistOperations.changeInput(e));
    },
    getMenu: function getMenu() {
      return dispatch(locationOperations.getMenu());
    },
    checkInWaitlist: function checkInWaitlist() {
      return dispatch(waitlistOperations.checkInWaitList());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(formikEnhancer(WaitlistFormPage));